<template>
  <div class="unCertification">
    <div class="ucList">
      <div class="ucItem">
        <div class="ucTitleBar">
          <div class="ucTitle">
            基础信息
          </div>
          <!-- <div class="btnGuide" @click="handleGuide"><i class="icon_quest"></i>新手引导</div> -->
          <Guide/>
        </div>
        <div class="border">
          <div class="uContent bg1">
            <div class="uCertificate">
              <div class="top">
                <div class="title">实名认证</div>
                <div class="desc" v-if="idCard===''">
                  完成实名认证即可查看数据档案详情、补充自填信息、申请勘误、生成个人<br/>信息报告。
                </div>
                <div class="desc" v-else>
                  因手机号码可通过过户、注销等情况变更用户信息，为确保手机号实名认证<br/>信息匹配，三个月内未登录的手机号码再次登陆时需重新完成实名认证。
                </div>
              </div>
              <div class="bottom">
                <btn
                  @handleClick="handleCertification"
                  btnText="进行实名认证"
                  :width="142"
                  :height="41"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ucItem">
        <div class="ucTitleBar">
          <div class="ucTitle">
            学历教育
          </div>
        </div>
        <div class="border">
          <div class="uContent bg2">
            <div class="uCertificate">
              <div class="top">
                <div class="title">实名认证</div>
                <div class="desc" v-if="idCard===''">
                  完成实名认证即可查看数据档案详情、补充自填信息、申请勘误、生成个人<br/>信息报告。
                </div>
                <div class="desc" v-else>
                  因手机号码可通过过户、注销等情况变更用户信息，为确保手机号实名认证<br/>信息匹配，三个月内未登录的手机号码再次登陆时需重新完成实名认证。
                </div>
              </div>
              <div class="bottom">
                <btn
                  @handleClick="handleCertification"
                  btnText="进行实名认证"
                  :width="142"
                  :height="41"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ucItem">
        <div class="ucTitleBar">
          <div class="ucTitle">
            非学历教育
          </div>
        </div>
        <div class="border">
          <div class="uContent bg3">
            <div class="uCertificate">
              <div class="top">
                <div class="title">实名认证</div>
                <div class="desc" v-if="idCard===''">
                  完成实名认证即可查看数据档案详情、补充自填信息、申请勘误、生成个人<br/>信息报告。
                </div>
                <div class="desc" v-else>
                  因手机号码可通过过户、注销等情况变更用户信息，为确保手机号实名认证<br/>信息匹配，三个月内未登录的手机号码再次登陆时需重新完成实名认证。
                </div>
              </div>
              <div class="bottom">
                <btn
                  @handleClick="handleCertification"
                  btnText="进行实名认证"
                  :width="142"
                  :height="41"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ucItem">
        <div class="ucTitleBar">
          <div class="ucTitle">
            职业经历
          </div>
        </div>
        <div class="border">
          <div class="uContent bg4">
            <div class="uCertificate">
              <div class="top">
                <div class="title">实名认证</div>
                <div class="desc" v-if="idCard===''">
                  完成实名认证即可查看数据档案详情、补充自填信息、申请勘误、生成个人<br/>信息报告。
                </div>
                <div class="desc" v-else>
                  因手机号码可通过过户、注销等情况变更用户信息，为确保手机号实名认证<br/>信息匹配，三个月内未登录的手机号码再次登陆时需重新完成实名认证。
                </div>
              </div>
              <div class="bottom">
                <btn
                  @handleClick="handleCertification"
                  btnText="进行实名认证"
                  :width="142"
                  :height="41"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ucItem">
        <div class="ucTitleBar">
          <div class="ucTitle">
            社会活动经历
          </div>
        </div>
        <div class="border">
          <div class="uContent bg5">
            <div class="uCertificate">
              <div class="top">
                <div class="title">实名认证</div>
                <div class="desc" v-if="idCard===''">
                  完成实名认证即可查看数据档案详情、补充自填信息、申请勘误、生成个人<br/>信息报告。
                </div>
                <div class="desc" v-else>
                  因手机号码可通过过户、注销等情况变更用户信息，为确保手机号实名认证<br/>信息匹配，三个月内未登录的手机号码再次登陆时需重新完成实名认证。
                </div>
              </div>
              <div class="bottom">
                <btn
                  @handleClick="handleCertification"
                  btnText="进行实名认证"
                  :width="142"
                  :height="41"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dialogGuide">
      <Cover
        :dialogGuide="dialogGuide"
        @dialogGuideClose="handleDialogGuideClose"
      >
        <ul slot="content">
          <li>
            <div>查看：</div>
            <div>
              为了准确匹配和查看数据档案，请您先完成实名认证，确认本人身份
            </div>
          </li>
          <li>
            <div>自填：</div>
            <div>
              您可以通过自填的方式补充填写您的数据档案。
            </div>
          </li>
          <li>
            <div>勘误：</div>
            <div>
              若您对数据档案中的具体数据有异议，可向数据来源方申请勘误。
            </div>
          </li>
          <li>
            <div>生成个人信息报告：</div>
            <div>
              您可以从数据档案中勾选必要信息生成个人信息报告，通过电子证书授权他人查看。
            </div>
          </li>
        </ul>
      </Cover>
    </div>
  </div>
</template>

<script>
import Btn from "./Btn.vue";
import Cover from "./Cover.vue";
import Guide from './Guide.vue';

export default {
  components: { Cover, Btn, Guide },
  props:{
    idCard:{
      type:String
    },
  },
  data() {
    return {
      dialogGuide: false,
      titles: ["基础信息", "学历教育", "非学历教育", "职业经历", "社会活动经历"]
    };
  },
  methods: {
    handleCertification() {
      this.$router.push({path:"realNameAuthentication",query:{idCard:this.idCard}});
    },
    handleGuide() {
      this.dialogGuide = true;
    },
    handleDialogGuideClose() {
      this.dialogGuide = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.unCertification {
  .ucList {
    .ucItem {
      margin-bottom: 23px;
      .ucTitleBar {
        display: flex;
        align-items: center;
        position: relative;
        &::before {
          content: "";
          border-left: 3px solid #3a61b1;
          height: 16px;
          position: absolute;
          top: 6px;
        }
        .btnGuide {
          font-size: 14px;
          color: #6e6e6e;
          margin-left: 5px;
          cursor: pointer;
          display: flex;
          align-items: center;
        }
        .ucTitle {
          font-size: 20px;
          color: #393939;
          padding-left: 10px;
          font-weight: bold;
        }
      }
      .ucContent {
        margin-top: 22px;
        position: relative;
        img {
          width: 100%;
        }
        .certificate {
          position: absolute;
          width: 635px;
          top: 82px;
          left: 92px;
          text-align: center;
          color: #fff;
          font-size: 20px;
          box-shadow: 0px 0px 10px 0px #dddddd;
          .top {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/pi2.png") no-repeat;
            background-size: 100%;
            padding: 38px 59px 34px 58px;

            .mt19 {
              margin-top: 19px;
            }
          }
          .bottom {
            border-radius: 8px 8px 0px 0px;
            padding: 27px 0 40px 0;
            background: #fff;
            position: relative;
            .radius {
              height: 20.5px;
              border-radius: 8px 8px 0px 0px;
              position: absolute;
              background: #fff;
              width: 100%;
              top: -7px;
            }
            button {
              border-radius: 20.5px;
              border: 0;
              background: #3a61b1;
              color: #fff;
              width: 142px;
              height: 41px;
            }
          }
        }
      }
    }
  }
}
.bg1 {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/unreal1.png");
  height: 290px;
}
.bg2 {
  background: url(https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/unreal2.png);
  height: 290px;
}
.bg3 {
  background: url(https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/unreal3.png);
  height: 290px;
}
.bg4 {
  background: url(https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/unreal4.png);
  height: 290px;
}
.bg5 {
  background: url(https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/unreal5.png);
  height: 290px;
}
.border {
  margin-top: 22px;
  border: 1px solid #f1f1f1;
}
.uContent {
  width: 800px;
  margin: 32px 23px 36px 23px;
  background-size: cover !important;
  display: flex;
  align-items: center;
  justify-content: center;

  .uCertificate {
    width: 635px;
    height: 235px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/pi2.png") no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-shadow: 0 0 16px 0px rgb(0 0 0 / 20%);
    .top {
      height: 135px;
      display: flex;
      justify-content: center;
      color: #fff;
      align-items: center;
      flex-direction: column;
      .title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 30px;
        margin-bottom: 5px;
      }
      .desc {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }
    }
    .bottom {
      border-radius: 8px 8px 0 0;
      height: 108px;
      background: #fff;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.icon_quest{
  background: url('https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_quest.png')no-repeat;
  background-size: cover;
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UnVerified.vue